import React from 'react'
// import PT from 'prop-types'
import Intro from './Intro/Intro'
import PostsContainer from './Post/PostsContainer'

const Home = () => (
  <div className="Home">
    <Intro />
    <PostsContainer />
  </div>
)

export default Home



// WEBPACK FOOTER //
// ./src/components/Home.js